/**
 * ゼンリンタイル取得失敗の観測ウィンドウ。
 *
 * `ZenrinTileLayer` の fetchImage はリトライ尽きると img を display:none にして
 * done(error) を呼び、Leaflet と waitForMapReady を進める「黙って失敗」する
 * 経路がある。これは出力プレビュー時に「全タイル失敗で白いプレビューを
 * 返してしまう」原因になるため、出力経路の前後でこのカウンタを開閉して
 * 失敗を検知できるようにする。
 *
 * - グローバル状態だが、出力経路は単一の連続処理（enlarge → fitBounds →
 *   waitForMapReady → createMapCanvas）の中で同時に複数走らせない前提のため
 *   実用上問題ない。
 * - レイヤー側 (ZenrinTileLayer) は recordZenrinTileFailure のみを参照し、
 *   出力側 (useMapImageExport) は begin / get のみを参照する。
 */
let failureCount = 0;

export const beginZenrinTileFailureWindow = (): void => {
  failureCount = 0;
};

export const recordZenrinTileFailure = (): void => {
  failureCount += 1;
};

export const getZenrinTileFailureCount = (): number => failureCount;
